const primaryColor = '#004f86';
const charts = {
  primaryColor: '#9A89FF', axisColor: '#cccccc', primaryColorGradient: '#beb3fd', secondaryColor: '#FCEBB0',
};

// eslint-disable-next-line import/prefer-default-export
export { primaryColor, charts };
